import {Injectable} from "@angular/core";
import {TranslocoService} from "@jsverse/transloco";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {of, switchMap, tap} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {GlobalService} from "../../../../global/global.service";
import {SaveFilterApiService} from "../save-filter.api.service";
import * as SavedFiltersActions from "./saved-filters.actions";

@Injectable({
    providedIn: 'root'
})
export class SavedListingFiltersEffects {

    constructor(private _actions$: Actions,
                private _globalService: GlobalService,
                private _saveFilterApiService: SaveFilterApiService,
                private _translocoService:TranslocoService
    ) {
    }


    fetchSavedFilters = createEffect(()=>{
        return this._actions$
            .pipe(
                ofType(SavedFiltersActions.fetchSavedFilters),
                switchMap(()=>this._saveFilterApiService.list()
                    .pipe(
                        map(filters=> SavedFiltersActions.fetchSavedFiltersSucceeded({filters})),
                        catchError(error => of(SavedFiltersActions.fetchSavedFiltersFailed({error})))
                    )
                )
            )
    });

    saveFilter = createEffect(()=>{
        return this._actions$
            .pipe(
                ofType(SavedFiltersActions.saveFilters),
                switchMap(({filter})=> {
                   return this._saveFilterApiService.create(filter)
                        .pipe(
                            map(filter => SavedFiltersActions.saveFiltersSucceeded({filter})),
                            catchError(error => of(SavedFiltersActions.saveFiltersFailed(error)))
                        )

                })

            )
    });


    saveFiltersSucceeded = createEffect(()=>{
        return this._actions$
            .pipe(
                ofType(SavedFiltersActions.saveFiltersSucceeded),
                tap(()=> {
                    this._globalService.toastrSuccess(this._translocoService.translate("Save notification (saved filters modal) - Filter has been saved"));
                })
            )
    },{dispatch:false})

    saveFiltersFailed = createEffect(()=>{
        return this._actions$
            .pipe(
                ofType(SavedFiltersActions.saveFiltersFailed),
                tap(({error})=> {
                    this._globalService.toastrError(error || this._translocoService.translate("Save filter failed (saved filters modal) - Could not save filter"));
                })
            )
    },{dispatch:false});

    editFilter = createEffect(()=>{
        return this._actions$
            .pipe(
                ofType(SavedFiltersActions.editSavedFilter),
                switchMap(({filter})=>{
                    return this._saveFilterApiService.update(filter.id, ({
                        name: filter.name,
                        public: filter.public,
                        type: filter.type,
                        value: filter.value
                    }))
                        .pipe(
                            map(()=> SavedFiltersActions.editSavedFilterSucceeded({filter})),
                            catchError(error => of(SavedFiltersActions.deleteSavedFilterFailed(error)))
                        )
                })
            )
    });

    editFilterSucceeded = createEffect(()=>{
        return this._actions$
            .pipe(
                ofType(SavedFiltersActions.editSavedFilterSucceeded),
                tap(()=> this._globalService.toastrSuccess(this._translocoService.translate("Update notification (saved filters modal) - Filter has been updated"))),
            )
    }, {dispatch:false});

    editFilterFailed = createEffect(()=>{
        return this._actions$
            .pipe(
                ofType(SavedFiltersActions.editSavedFilterFailed),
                tap(({error})=> {
                    this._globalService.toastrError(error || this._translocoService.translate('Update filter failed (saved filters modal) - Could not update filter'));
                })
            )
    }, {dispatch:false});

    deleteFilter = createEffect(()=>{
       return this._actions$
           .pipe(
               ofType(SavedFiltersActions.deleteSavedFilter),
               switchMap(({filterId})=>{
                   return this._saveFilterApiService.delete(filterId)
                       .pipe(
                           map(()=> SavedFiltersActions.deleteSavedFilterSucceeded({filterId})),
                           catchError(error => of(SavedFiltersActions.deleteSavedFilterFailed(error)))
                       )
               })
           )
    });

    deleteFilterSucceeded = createEffect(()=>{
       return this._actions$
           .pipe(
               ofType(SavedFiltersActions.deleteSavedFilterSucceeded),
               tap(()=> this._globalService.toastrSuccess(this._translocoService.translate("Delete notification (saved filters modal) - Filter has been deleted"))),
           )
    }, {dispatch:false});

    deleteFilterFailed = createEffect(()=>{
       return this._actions$
           .pipe(
               ofType(SavedFiltersActions.deleteSavedFilterFailed),
               tap(({error})=> {
                   this._globalService.toastrError(error || this._translocoService.translate("Delete filter failed (saved filters modal) - Could not delete filter"));
               })
           )
    }, {dispatch:false});
}